export var summaryDescription = 'View and redeem your Perks here. You can also manage and redeem them\n' +
    '        using your Home Depot app. Click on the Perk(s) below for more details.';
export var noPerksSummary = 'Your Perks Spend brings you closer to unlocking your next Perk.';
export var perksModalText = {
    hasPerksTitle: 'Pro Xtra Perk Details',
    finalConfirmation: 'All Pro Xtra Perks are final after confirmation',
    howTo: 'To redeem in-store, access your Perk from the Account section\n' +
        '                  of your profile through The Home Depot app or at homedepot.com on\n' +
        '                  a browser.',
    errorMessage: 'An error has occurred. Please try again.',
    scanBarcode: 'Scan barcode and enter the pin below at in store checkout.',
    scanBarcodeExon: 'Scan barcode below at Home Depot to redeem your $5 Coupon. Do not scan barcode at Exxon or Mobil stations.',
    errorBarcodeMessage: 'An error has occurred. Please tap refresh.',
    errorBarcodeRefresh: 'Refresh',
};
export var buttonText = {
    cardsAndAccounts: 'Go To Cards & Accounts',
    viewDetails: 'View Details',
};
export var perksHistory = {
    renewed: 'Renewed',
    exchanged: 'Exchanged',
    summary: 'View a timeline of your unlocked Perks.',
};
